/* script */
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import MobilePreview from 'ui/components/theme/MobilePreview.vue';
import WebPreview from 'ui/components/theme/WebPreview.vue';

const __vue_script__ = {
    name: 'AppsPreview',

    components: {
        MobilePreview,
        WebPreview
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        theme: {
            type: Object,
            default: null
        },

        model: {
            type: Object,
            default: () => ({
                banner: null,
                quick_links: [0, 1, 2, 3, 4, 5]
            })
        }
    },

    data() {
        return {
            innerTheme: null,
            preview: 'web',
            banner: null,
            quickLinks: this.model.quick_links.length
        };
    },

    computed: {
        appearance() {
            if (!this.innerTheme) {
                return {};
            }

            const appearance = {};
            for (const [prop, { paths, defaultValue }] of Object.entries(this.$services.theme.V2_THEME_MAPPING)) {
                paths.forEach(path => appearance[prop] = get(this.innerTheme, path, defaultValue));
            }

            return appearance;
        }
    },

    watch: {
        model: {
            deep: true,
            handler() {
                this.setValues(this.model);
            }
        }
    },

    async created() {
        await this.init();
    },

    methods: {
        async init() {
            try {
                this.innerTheme = this.theme;
                if (!this.innerTheme) {
                    this.innerTheme = await this.$services.theme.getTheme(this.event._id);
                }

                const settings = await this.$services.settings.getSetting(this.event._id, 'home-feed');
                this.setValues(settings);
            } catch (error) {
                console.error('[AppsPreview] Could not load the theme', error.message);
            }
        },

        setValues(values) {
            this.banner = values.banner ? this.$utils.assets.getEventAssetPath(this.event._id, values.banner) : null;
            this.quickLinks = values.quick_links.length;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.innerTheme)?_c('div',{staticClass:"apps-preview"},[_c('section',{staticClass:"previews"},[_c('div',{staticClass:"buttons-toggler"},[_c('button',{staticClass:"btn",class:{'btn-primary-alt': _vm.preview === 'web'},attrs:{"type":"button"},on:{"click":function($event){_vm.preview = 'web'}}},[_vm._v(_vm._s(_vm.$t('theme.editor.previews.web')))]),_c('button',{staticClass:"btn",class:{'btn-primary-alt': _vm.preview === 'mobile'},attrs:{"type":"button"},on:{"click":function($event){_vm.preview = 'mobile'}}},[_vm._v(_vm._s(_vm.$t('theme.editor.previews.mobile')))])]),_c('div',{staticClass:"environments"},[(_vm.preview === 'web')?_c('web-preview',{attrs:{"theme":_vm.appearance,"quick-links":_vm.quickLinks,"banner":_vm.banner}}):_vm._e(),(_vm.preview === 'mobile')?_c('mobile-preview',{attrs:{"theme":_vm.appearance,"quick-links":_vm.quickLinks,"banner":_vm.banner}}):_vm._e()],1)])]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AppsPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__